/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Standings_GpInputs */



/**
* | output |
* | --- |
* | "Grand Prix" |
*
* @param {League_Standings_GpInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_standings_gp = /** @type {((inputs?: League_Standings_GpInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Standings_GpInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Grand Prix")
	if (locale === "es") return /** @type {LocalizedString} */ ("Grand Prix")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Grand Prix")
	if (locale === "it") return /** @type {LocalizedString} */ ("Grand Prix")
	return /** @type {LocalizedString} */ ("Grand Prix")
});